import { faUser } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useCallback, useContext, useEffect, useState } from "react"
import { Skeleton } from "antd"
import { getUserById, logoutUser } from "../services/UserService"
import UserContext from "../context/UserContext"
import '../assets/css/Profil.css'
import { Link, useNavigate } from "react-router-dom"
import { useModalContext } from "../context/ModalContext"
import { MODAL_DESCRIPTION_ERROR_UNAUTHORIZED, MODAL_MESSAGE_ERROR, MODAL_TYPE_ERROR } from "../HistoriografijaConstants"

function Profil() {
    const { userId, clearUserContext } = useContext(UserContext)
    const {displayGenericErrorModal, displayMessageModalWithParameters} = useModalContext()
    const [user, setUser] = useState()
    const navigate = useNavigate()

    const handleException = useCallback((err) => {
        if (err?.response?.status === 401) {
            displayMessageModalWithParameters(MODAL_MESSAGE_ERROR, MODAL_DESCRIPTION_ERROR_UNAUTHORIZED, MODAL_TYPE_ERROR)
            // log the user out
            logoutUser()
                .then(data => {
                    clearUserContext()
                    navigate('/')
                })
                .catch(error => {
                    displayGenericErrorModal()
                    navigate('/')
                })
        } else {
            displayGenericErrorModal()
        }
    }, [displayMessageModalWithParameters,  clearUserContext, displayGenericErrorModal])

    const getUserProfile = useCallback((userId) => {
        getUserById(userId)
        .then(data => {
            setUser(data)
        })
        .catch(err => handleException(err))
    }, [setUser, handleException])

    useEffect(() => {
        if (userId) {
            getUserProfile(userId)
        }
    }, [userId, getUserProfile])

    return (
        <div className="flex-container flex-column full-width">

            <div className="flex-container center-align height-20p center-justify gray-header height-header">
                <FontAwesomeIcon icon={faUser} className="text-gray font-3rem"></FontAwesomeIcon>
                {user ? 
                    <h1 className="left-margin-5p">{user.firstName + ' ' + user.lastName}</h1>
                    :
                    <Skeleton active paragraph={{rows: 0}}/>
                }
            </div>

            <div className="flex-container height-80p flex-column width-80p center-align profile-main-part">
                
                <div className="flex-container full-width center-align center-justify top-margin-5">
                    <div className="flex-container flex-column width-45p text-end right-margin-5p">
                        <p>Korisničko ime</p>
                        <p>Email</p>
                        <p>Datum kreiranja računa</p>
                    </div>

                    <div className="flex-container flex-column width-45p profile-info-container">
                        {user ? <p>{user.username}</p>
                            :
                            <Skeleton active paragraph={{rows: 0}}/>
                        }

                        {user ? <p>{user.email}</p>
                            :
                            <Skeleton active paragraph={{rows: 0}}/>
                        }

                        {user ? <p>{user.dateCreated}</p>
                            :
                            <Skeleton active paragraph={{rows: 0}}/>
                        }
                    </div>
                </div>

                <div className="flex-container full-width center-align center-justify top-margin-5">
                    <div className="flex-container flex-column width-45p text-center">
                        <Link to={"/change-password"}>Promijeni lozinku</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Profil